
const headerData = (title) => {
    const headerVal = []
    headerVal[0] = title
    headerVal[1] = ''
    headerVal[2] = ''
    return headerVal
}

const excelBody = (vm) => {
    const listContractor = []
    vm.report_data.forEach((element, index) => {
        const myObj = {}
        myObj[vm.$t('globalTrans.sl_no')] = vm.$n(index + 1)
        myObj[vm.$t('institute_manangement.evaluation_date')] = vm.$options.filters.dateFormat(element.evaluation_date)
        myObj[vm.$t('rehabilitation_management.registration_id')] = '\'' + element.registration_id + '\''
        myObj[vm.$t('child_reports.resident_name')] = vm.$i18n.locale === 'en' ? element.name_ : element.name_bn
        myObj[vm.$t('child_reports.evaluation_setting')] = element.details && element.details.length > 0
        ? element.details.map(detail => vm.getEvaluationName(detail)).join(', ')
        : ''
        myObj[vm.$t('child_reports.obtain_m')] = element.details && element.details.length > 0
            ? element.details.map(detail => vm.$n(detail.obtain_marks)).join(', ')
            : ''
        myObj[vm.$t('child_reports.total_m')] = element.details && element.details.length > 0
            ? vm.getTotal(element.details)
            : ''
        myObj[vm.$t('globalTrans.remarks')] = (element.remarks)

        listContractor.push(myObj)
    })
    return listContractor
}

export default {
    headerData,
    excelBody
}
